import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { optionsStatus, roleId, urls } from "../../constants/app";
import request from "../../action/utils/request";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import swal from 'sweetalert';
import { fetchPayments } from '../../action/handbook';
import { checkSorucePromotions, validatePromocode, validatePromotions } from '../../utils/common';
import { withRouter } from 'react-router-dom';
import { clearHistoryOrders } from '../../action/historyOrders';
import { isEmpty } from 'lodash';
import { clearNewOrder } from '../../action/neworder';

const paymentTitle = {
    cash: 'Наличные',
    terminal: 'Терминал',
    online: 'Юкасса',
};

const сashTitle = {
    no: 'под расчет',
    c1000: 'сдача с 1000',
    c1500: 'сдача с 1500',
    c2000: 'сдача с 2000',
    c5000: 'сдача с 5000',
};

const SaveNewOrderButton = ({history, editOrder, editedOrder}) => {
    const dispatch = useDispatch();
    const stateNewOrders = useSelector(state => state.neworders);
    const userInfo = useSelector(state => state.user.info);
    const settings = useSelector(state => state.settings.init.categories);
    const idPointCC = useSelector(state => state.settings.init.idPointCC);
    const payments = useSelector( state => state.handbook.payments);
    const historyOrders = useSelector(state => state.historyOrders.list);
    const filials = useSelector(state => state.handbook.filials);

    useEffect(() => {
        const getPayments = async () => {
            await Promise.all([
                dispatch(fetchPayments(true))
            ]);
            payments.map((payment) => {
                return paymentTitle[payment.Name] = payment.VisibleName;
            });
        }

        getPayments();
        // eslint-disable-next-line
    }, [dispatch])

    const isValidOrder = () => {
        if (userInfo.role.id === roleId.qualityControlManager) return false;
        if (stateNewOrders.goods.length <= 0) return false;
        if (userInfo.role.id === roleId.operator && stateNewOrders.deliveryMethod === 'delivery' && !stateNewOrders.isAggPrice) {
            if (!stateNewOrders.street || !stateNewOrders.house) return false;            
        }
        return true;
    }

    const getWorkingShift = async () => {
        const params = {
            'closed_at_null': true,
            'point.id': stateNewOrders.point.id
        };
        const workingShift = await request({ method: 'get', url: urls.workingShift, params });
        return workingShift;        
    }

    const renderAddress = (order) => {
        return `${order.area ? order.area : ''}${order.street ? ', ' + order.street : ''}${order.house ? ', ' + order.house : ''}${order.entrance ? `, подъезд ${order.entrance}` : ''}${order.floor ? `, этаж ${order.floor}` : ''}${order.room ? `, кв./оф. ${order.room}` : ''}`;
    }

    const saveChangeLog = () => {
        const date = new Date();
        const order = stateNewOrders;        
        let changeLog = {};

        if(renderAddress(order) !== renderAddress(editedOrder)){
            changeLog = {
                ...changeLog,
                address: `Адрес изменен с ${renderAddress(editedOrder)} на ${renderAddress(order)}`
            }
        }

        if(order.phone !== editedOrder.phone){
            changeLog = {
                ...changeLog,
                phone: `Номер телефона изменен с ${editedOrder.phone} на ${order.phone}`
            }
        }

        if(order.bonusCount !== editedOrder.bonusCount){
            changeLog = {
                ...changeLog,
                bonusCount: `Кол-во бонусов изменено с ${editedOrder.bonusCount} на ${order.bonusCount}`
            }
        }

        if(order.changeCash !== editedOrder.changeCash){
            changeLog = {
                ...changeLog,
                changeCash: `Сдача изменена с ${сashTitle[editedOrder.changeCash]} на ${сashTitle[order.changeCash]}`
            }
        }

        if(order.payment !== editedOrder.payment){
            changeLog = {
                ...changeLog,
                payment: `Способ оплаты изменен с ${paymentTitle[editedOrder.payment]} на ${paymentTitle[order.payment]}`
            }
        }

        if(order.city && order.city.id !== editedOrder.city.id){
            changeLog = {
                ...changeLog,
                city: `Город изменен с ${editedOrder.city.name} на ${order.city.name}`
            }
        }

        if (editedOrder && editedOrder.zone && editedOrder.zone.point) {
            if (editedOrder.zone.point.id) {
                editedOrder.point = editedOrder.zone.point.id;
            } else {
                editedOrder.point = { id: editedOrder.zone.point };
            }
        }
        
        if(order.point && order.point.id !== editedOrder.point.id){
            const renderLogAdress = (city, point) => {
                if(!city && !point)
                    return 'Не определен'
                return `${city ? city.name : 'Город не определен'}${point ? `, ${point.street} ${point.house}` : ', филиал не определен'}`
            }
            changeLog = {
                ...changeLog,
                oldPoint: editedOrder.point ? editedOrder.point.id ? editedOrder.point.id : editedOrder.point : null,
                newPoint: order.point ? order.point.id ? order.point.id : order.point : null,
                point: `Филиал изменен с ${renderLogAdress(editedOrder.city, editedOrder.point)} на ${renderLogAdress(order.point.city, order.point)}`
            }
        }

        if(order.zone && order.zone.point){
            let point = null

            if(!order.zone.point.id) {
                point = filials.find((el) => el.id === order.zone.point)
            } else {
                point = order.zone.point
            }

            if(point && point.id !== editedOrder.point.id) {
                const renderLogAdress = (city, point) => {
                    if(!city && !point)
                        return 'Не определен'
                    return `${city ? city.name : 'Город не определен'}${point ? `, ${point.street} ${point.house}` : ', филиал не определен'}`
                }
                changeLog = {
                    ...changeLog,
                    oldPoint: editedOrder.point ? editedOrder.point.id ? editedOrder.point.id : editedOrder.point : null,
                    newPoint: point ? point.id ? point.id : point : null,
                    point: `Филиал изменен с ${renderLogAdress(editedOrder.city, editedOrder.point)} на ${renderLogAdress(order.point.city, point)}`
                }
            }
        }

        if(order.internalComment !== editedOrder.internalComment){
            changeLog = {
                ...changeLog,
                internalComment: `Комментарий изменен с ${editedOrder.internalComment} на ${order.internalComment}`
            }
        }

        if(order.deliveryMethod !== editedOrder.deliveryMethod){
            changeLog = {
                ...changeLog,
                deliveryMethod: `Тип заказа изменен с ${editedOrder.deliveryMethod === 'own' ? 'Вынос' : 'Доставка'} на ${order.deliveryMethod === 'own' ? 'Вынос' : 'Доставка'}`
            }
        }

        if(order.deliveryPrice !== editedOrder.deliveryPrice){
            changeLog = {
                ...changeLog,
                deliveryPrice: `Стоимость доставки изменена с ${editedOrder.deliveryPrice} на ${order.deliveryPrice}`
            }
        }

        if(order.deliveryTime !== editedOrder.deliveryTime){
            changeLog = {
                ...changeLog,
                deliveryTime: `Время доставки изменено с ${editedOrder.deliveryPrice} на ${order.deliveryPrice}`
            }
        }

        if(order.isAggPrice !== editedOrder.isAggPrice){
            if(order.isAggPrice) {
                changeLog = {
                    ...changeLog,
                    isAggPrice: `Цены изменены на цены агрегаторов`
                }
            } else {
                changeLog = {
                    ...changeLog,
                    isAggPrice: `Цены изменены на обычные`
                }
            }
        }

        if(order.promocode !== editedOrder.promocode){
            if(order.promocode) {
                changeLog = {
                    ...changeLog,
                    promocode: `Применен промокод ${order.promocode.name}`
                }
            } else {
                changeLog = {
                    ...changeLog,
                    promocode: `Примененный ранее промокод удален из заказа`
                }
            }
        }

        if(parseFloat(order.salePrice) !== parseFloat(editedOrder.salePrice)){
            changeLog = {
                ...changeLog,
                salePrice: `Скидка изменена с ${editedOrder.salePrice} на ${order.salePrice}`
            }
        }

        if(order.visible_datetime !== editedOrder.visible_datetime){
            changeLog = {
                ...changeLog,
                visible_datetime: `Отображаемое время заказа изменено с ${editedOrder.visible_datetime ? moment(editedOrder.visible_datetime).format('HH:mm DD.MM.YYYY') : moment(editedOrder.created_at).format('HH:mm DD.MM.YYYY')} на ${moment(order.visible_datetime, 'DD.MM.YYYY HH:mm').format('HH:mm DD.MM.YYYY')}`
            }
        }

        if(order.unit !== editedOrder.unit){
            changeLog = {
                ...changeLog,
                unit: `Изменено кол-во приборов с ${editedOrder.unit} на ${order.unit}`
            }
        }

        order.goods.map((item) => {
            let name = 'NaN';

            if(item.wokData) {
                name = item.wokData.main.title;
            } else {
                if(item.name) 
                    name = item.name;
                
                if(item.data && item.data.title)
                    name = item.data.title;                
            }

            if(item.addCount !== item.count && item.changeMod){
                changeLog = {
                    ...changeLog,
                    changeMod: {
                        ...(changeLog.addGood || {}),
                        [item.id]: `Изменен размер ${name} с ${item.isMod ? '30см' : '36см'} на ${item.isMod ? '36см' : '30см'}`
                    }
                }
            }

            if(!item.wokData && item.addCount && item.addCount !== 0) {
                if(item.addCount === item.count) {                                                
                    changeLog = {
                        ...changeLog,
                        addGood: {
                            ...(changeLog.addGood || {}),
                            [item.id]: `Добавлена позиция ${name}${(item.category === settings.pizza || (item.categoryName && item.categoryName.toLowerCase() === 'пицца')) ? item.isMod ? ' 36см' : ' 30см' : ''} кол-во: ${Math.abs(item.addCount)}`
                        }
                    }
                } else {
                    if(item.addCount > 0) {
                        changeLog = {
                            ...changeLog,
                            editCount: {
                                ...(changeLog.editCount || {}),
                                [item.id]: `Увеличено кол-во ${name}${(item.category === settings.pizza || (item.categoryName && item.categoryName.toLowerCase() === 'пицца')) ? item.isMod ? ' 36см' : ' 30см' : ''} на ${Math.abs(item.addCount)}`
                            }
                        }
                    } else {
                        changeLog = {
                            ...changeLog,
                            editCount: {
                                ...(changeLog.editCount || {}),
                                [item.id]: `Уменьшено кол-во ${name}${(item.category === settings.pizza || (item.categoryName && item.categoryName.toLowerCase() === 'пицца')) ? item.isMod ? ' 36см' : ' 30см' : ''} на ${Math.abs(item.addCount)}`
                            }
                        }
                    }
                }
            }

            if(item.wokData) {
                let oldMeat = null
                let oldTopping = null
                let oldSouce = null
                let newMeat = null
                let newTopping = null
                let newSouce = null

                if(item.wokData.meat) 
                    Object.values(item.wokData.meat).map((el) => {                            
                        oldMeat = `${oldMeat ? oldMeat + ', ' : ''}${el.addCount !== el.count ? `${el.data.title} x${el.count - (el.addCount || 0)}` : ''}`
                        newMeat = `${newMeat ? newMeat + ', ' : ''}${el.data.title} x${el.count}`
                        return el                            
                })

                if(item.wokData.topping) 
                    Object.values(item.wokData.topping ).map((el) => {
                        oldTopping = `${oldTopping ? oldTopping + ', ' : ''}${el.addCount !== el.count ? `${el.data.title} x${el.count - (el.addCount || 0)}` : ''}`
                        newTopping = `${newTopping ? newTopping + ', ' : ''}${el.data.title} x${el.count}`
                        return el
                })

                if(item.wokData.souce) 
                    Object.values(item.wokData.souce).map((el) => {
                        oldSouce = `${oldSouce ? oldSouce + ', ' : ''}${el.addCount !== el.count ? `${el.title} x${el.count - (el.addCount || 0)}` : ''}`
                        newSouce = `${newSouce ? newSouce + ', ' : ''}${el.title} x${el.count}`
                        return el
                })

                const oldIngredientsWok = `${name} x${item.count - (item.addCount || 0)}${oldMeat ? `, мясо: ${oldMeat}` : ''}${oldTopping ? `, топпинги: ${oldTopping}` : ''}${oldSouce ? `, соусы: ${oldSouce}` : ''}`
                const newIngredientsWok = `${name} x${item.count}${newMeat ? `, мясо: ${newMeat}` : ''}${newTopping ? `, топпинги: ${newTopping}` : ''}${newSouce ? `, соусы: ${newSouce}` : ''}`

                const chekId = item.wokData.id || item.id
                if(item.count - (item.addCount || 0) === 0){
                    changeLog = {
                        ...changeLog,
                        addWok: {
                            ...(changeLog.editWok || {}),
                            [chekId]: `Добавлен ВОК ${newIngredientsWok}`
                        }
                    }
                } else {
                    if(newIngredientsWok !== oldIngredientsWok){
                        changeLog = {
                            ...changeLog,
                            editWok: {
                                ...(changeLog.editWok || {}),
                                [chekId]: `ВОК ${oldIngredientsWok} изменен состав на ${newIngredientsWok}`
                            }
                        }
                    }
                }
            }
            return item
        })

        if(order.removedGoods.filter(removedPosition => removedPosition.addCount !== removedPosition.count).length > 0){
            const logRemovedGoods = order.removedGoods.map((removedPosition) => {
                if(removedPosition.addCount !== removedPosition.count) {
                    if(!removedPosition.wokData) {
                        return(`${removedPosition.name ? removedPosition.name : removedPosition.data.title}${(removedPosition.category === settings.pizza || (removedPosition.categoryName && removedPosition.categoryName.toLowerCase() === 'пицца')) ? removedPosition.isMod ? ' 36см' : ' 30см' : ''} x${removedPosition.count - (removedPosition.addCount || 0) }`)
                    } else {
                        let meat = null
                        let topping = null
                        let souce = null
                        if(removedPosition.wokData.meat) 
                            Object.values(removedPosition.wokData.meat).map((el) => {                            
                                meat = `${meat ? meat + ', ' : ''}${el.data.title} x${el.count}`
                                return el                            
                        })
        
                        if(removedPosition.wokData.topping) 
                            Object.values(removedPosition.wokData.meat).map((el) => {
                                topping = `${topping ? topping + ', ' : ''}${el.data.title} x${el.count}`
                                return el
                        })
        
                        if(removedPosition.wokData.souce) 
                            Object.values(removedPosition.wokData.souce).map((el) => {
                                souce = `${souce ? souce + ', ' : ''}${el.addCount !== el.count ? `${el.title} x${el.count - (el.addCount || 0)}` : ''}`
                                return el
                        })

                        return(`${removedPosition.wokData.main.title} x${removedPosition.count}${meat ? `, мясо: ${meat}` : ''}${topping ? `, топпинги: ${topping}` : ''}${souce ? `, соусы: ${souce}` : ''}`)
                    }
                }
                return removedPosition
            })

            const logRemovedGoodsName = 'removedGoods_' + moment(date).format('DD.MM.YYYY HH:mm:ss')
            if(logRemovedGoods.length > 1) {
                changeLog = {
                    ...changeLog,
                    removedPosition: {
                        ...(changeLog.removedPosition || {}),
                        [logRemovedGoodsName]: `Удалены позиции: ${logRemovedGoods.join(', ')}`
                    }
                }
            } else {
                changeLog = {
                    ...changeLog,
                    removedPosition: {
                        ...(changeLog.removedPosition || {}),
                        [logRemovedGoodsName]: `Удалена позиция: ${logRemovedGoods.join(', ')}`
                    }
                }
            }
        }

        let checkChangeLog = {};
        let log = order.changeLog;

        if(log) {
            if(typeof log === 'string') {
                checkChangeLog = JSON.parse(log);
            } else {
                checkChangeLog = log;
            }
        }

        const username = userInfo.name ? userInfo.name : userInfo.username;
        const roleDescription = userInfo.role && userInfo.role.description ? userInfo.role.description : ''
        const userText = `${username} ${roleDescription}`;
        
        const logName = String(userInfo.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

        checkChangeLog[logName] = {
            user: userText,
            date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
            ...changeLog
        }


        return checkChangeLog
    }

    const validatePoromoNewOrder = () => {
        const { promocode, promotion, isChangePromo, deliveryMethod, totalPrice, goodsPrice, point, city } = stateNewOrders;
        const newOrderCity = city ? city : (point && point.city) ? stateNewOrders.point.city : null;

        if (promotion) {
            let promoData = null;
            if (stateNewOrders.promoData) {
                promoData = stateNewOrders.promoData;
            } else {
                promoData = promotion;
            }

            let sum = 0;

            if (promoData && promoData.type && promoData.type === 'addGoods') {
                let goodCost = goodsPrice != null ? goodsPrice : totalPrice;
                let promoPrice = 0;
                if (promoData.goods && promoData.goods.length > 0) promoPrice = promoData.goods.reduce((acc, item) => acc + item.sale, 0);
                sum = goodCost - promoPrice;
            }

            if (!sum) sum = goodsPrice != null ? goodsPrice : totalPrice;

            if (!validatePromotions(newOrderCity, deliveryMethod, sum, historyOrders, isChangePromo)(promoData)) {
                return swal({
                    title: "Условия акции не соблюдены.",
                    icon: "warning",
                    text: 'Исправьте заказ или отмените использование акции.',
                    dangerMode: true,
                    button: "Вернуться к заказу"
                }).then(() => {
                    return false;
                });
            }
        }

        if (promocode) {
            let promoData = null;
            if (stateNewOrders.promoData) {
                promoData = stateNewOrders.promoData;
            } else {
                promoData = promocode;
            }
            
            let sum = 0;
            
            if (promoData && promoData.type && promoData.type === 'addGoods') {
                let goodCost = goodsPrice != null ? goodsPrice : totalPrice;
                let promoPrice = 0;
                if (promoData.goods && promoData.goods.length > 0) promoPrice = promoData.goods.reduce((acc, item) => acc + item.sale, 0);
                sum = goodCost - promoPrice;
            }

            if (!sum) sum = goodsPrice != null ? goodsPrice : totalPrice;
            
            const hasError = validatePromocode(promoData, deliveryMethod, newOrderCity, sum, checkSorucePromotions(userInfo.role.id), isChangePromo);
            if (hasError) {
                return swal({
                    title: "Условия промокода не соблюдены.",
                    text: hasError + ' Исправьте заказ или отмените использование промокода.',
                    icon: "warning",
                    dangerMode: true,
                    button: "Вернуться к заказу"
                }).then(() => {
                    return false;                   
                });
            }
        }

        return true;
    }

    const handleClickSave = async () => {
        const isValidPromo = await validatePoromoNewOrder();
        if (!isValidPromo) return null;
        let changeLog = null
        if (editOrder) changeLog = saveChangeLog();

        // Проверка изменения статуса
        let statusChangeLog = null;
        if (editOrder && editedOrder && stateNewOrders.status !== editedOrder.status) {
            if (stateNewOrders.status === 'cancel') {
                const willDelete = await swal({
                    title: "Изменение статуса заказа",
                    text: "Вы действительно хотите отменить заказ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Отмена", "Отменить заказ"],
                });
                if (!willDelete) return null;
            }
            if (stateNewOrders.status === 'written-off') {
                const willDelete = await swal({
                    title: "Изменение статуса заказа",
                    text: "Вы действительно хотите списать заказ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Отмена", "Списать заказ"],
                });
                if (!willDelete) return null;
            }

            let checkChangeStatusLog = null;
            if (stateNewOrders.changeStatusLog) {
                if (typeof stateNewOrders.changeStatusLog === 'string') {
                    checkChangeStatusLog = JSON.parse(stateNewOrders.changeStatusLog);
                } else {
                    checkChangeStatusLog = stateNewOrders.changeStatusLog;
                }
            }

            const date = new Date();
            const logName = String(stateNewOrders.status + '-' + (checkChangeStatusLog ? Object.keys(checkChangeStatusLog).length : 0) + '__' + moment(date).format('DD.MM.YYYY'));
            const username = userInfo.name ? userInfo.name : userInfo.username;
            const roleDescription = userInfo.role && userInfo.role.description ? userInfo.role.description : '';
            const userText = `${roleDescription} ${username}`;

            statusChangeLog = {
                ...checkChangeStatusLog,
                [logName]: {
                    status: stateNewOrders.status,
                    date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                    user: userText
                }
            };
        }

        dispatch({ type: 'SET_LOADER', field: 'loadingSaveOrder', value: true });

        if (stateNewOrders.point.id !== idPointCC && stateNewOrders.point.atolData && stateNewOrders.point.atolData.activate) {
            const workingShift = await getWorkingShift();
            if (workingShift.length <= 0) {
                dispatch({ type: 'SET_LOADER', field: 'loadingSaveOrder', value: false });
                return swal({
                    title: "Смена закрыта",
                    text: "Смена закрыта, создание заказа невозможно. Откройте смену и повторите попытку.",
                    icon: "warning",
                    dangerMode: true,
                    button: "Ок",
                })
            }
        }

        const order = createNewOrder(changeLog, statusChangeLog);

        if (order.error) {
            dispatch({ type: 'SET_LOADER', field: 'loadingSaveOrder', value: false });
            return swal({
                title: "Ошибка сохранения заказа",
                text: order.error,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        if(window.location.pathname.includes('/edit')) {
            if(stateNewOrders.id) {
                let url = urls.orders
                if(window.location.pathname.includes('/archive')) url = urls.archive;
                return request({ method: 'put', url: `${url}/${stateNewOrders.id}`, data: order })
                .then((res) => {
                    if (res.error) {
                        return swal({
                            title: "Ошибка сохранения заказа",
                            text: res.error.message || '',
                            icon: "error",
                            dangerMode: true,
                            button: "Ок",
                        });
                    }
                    dispatch(clearNewOrder());
                    dispatch(clearHistoryOrders());
                    history.push('/orders');
                    return true;
                })
                .catch(er => {
                    return swal({
                        title: "Ошибка обновления заказа",
                        text: 'Ошибка ' + er.status,
                        icon: "error",
                        dangerMode: true,
                        button: "Ок",
                    });
                })
                .finally(() => {
                    dispatch({ type: 'SET_LOADER', field: 'loadingSaveOrder', value: false });
                });
            } else {
                return swal({
                    title: "Ошибка обновления заказа",
                    text: 'Ошибка не найден id заказа',
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            }
        } else {
            return request({ method: 'post', url: urls.orders, data: order })
            .then((res) => {
                if (res.error) {
                    return swal({
                        title: "Ошибка сохранения заказа",
                        text: res.error.message || '',
                        icon: "error",
                        dangerMode: true,
                        button: "Ок",
                    });
                }
                dispatch(clearNewOrder());
                dispatch(clearHistoryOrders());
                history.push('/orders');
            })
            .catch((er) => {
                return swal({
                    title: "Ошибка сохранения заказа",
                    text: `Ошибка ${er.status}`,
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            })
            .finally(() => {
                dispatch({ type: 'SET_LOADER', field: 'loadingSaveOrder', value: false });
            })
        }
    }
    
    const createNewOrder = (changeLog, statusChangeLog) => {
        let checkChangeCash = stateNewOrders.changeCash
        let checkComment = stateNewOrders.internalComment ? String(stateNewOrders.internalComment) : null;
        if (stateNewOrders.changeCash && !['no', 'c1000', 'c1500', 'c2000', 'c5000'].includes(stateNewOrders.changeCash))
        {
            checkComment = checkComment + String(stateNewOrders.changeCash ? ' | сдача с '+ stateNewOrders.changeCash.slice(1) : '')
        }
    
        const checkGoods = stateNewOrders.goods.map((item) => {
            if(!item.wokData)
                return {
                    id: String(item.id),
                    article: item.article,
                    isMod: item.isMod ? !item.isMod.default : false,
                    count: item.count,
                    isWok: false,
                    wokData: null,
                    price: stateNewOrders.isAggPrice ? (item.oldPrice ? item.oldPrice : item.price) : item.price,
                    category: item.category ? item.category.id ? item.category.id : item.category : null,
                    categoryName: item.categoryName ? item.categoryName : (item.category && item.category.title) ? item.category.title : null,
                    isPromo: item.isPromo,
                    markedCodes: item.markedCodes || null,
                    data: {
                        title: (item.data && item.data.title)? item.data.title : item.name ? item.name : null,
                        weight: (item.data && item.data.weight) ? item.data.weight : item.weight ? item.weight : 0,
                    },
                }
    
            const hash = (() => {
                const check = {
                    [item.id]: 1,
                };
                if(item.wokData.souce)
                Object.values(item.wokData.souce).forEach((item) => {
                    check[item.id] = 1;
                });
                if (item.wokData.meat) {
                Object.values(item.wokData.meat).forEach((item) => {
                    check[item.id] = item.count;
                    });
                }
                if (item.wokData.topping) {
                Object.values(item.wokData.topping).forEach((item) => {
                    check[item.id] = item.count;
                    });
                }
                const uuid = uuidv4(JSON.stringify(check));
                return uuid;
                });
                
            const WokDataCheck = {
                ...item.wokData,
                id: hash(),
                price: stateNewOrders.isAggPrice ? (item.wokData.oldPrice ? item.wokData.oldPrice : item.wokData.price) : item.wokData.price,
                meat: Object.keys(item.wokData.meat).reduce((acc, key) => {
                    const meatItem = item.wokData.meat[key];
                    acc[key] = {
                      count: meatItem.count,
                      article: meatItem.article,
                      data: meatItem.data
                    };
                    return acc;
                }, {}),
                topping: Object.keys(item.wokData.topping).reduce((acc, key) => {
                    const toppingItem = item.wokData.topping[key];
                    acc[key] = {
                      count: toppingItem.count,
                      article: toppingItem.article,
                      data: toppingItem.data
                    };
                    return acc;
                }, {}),
                souce: Object.keys(item.wokData.souce).reduce((acc, key) => {
                    const souceItem = item.wokData.souce[key];
                    acc[key] = {
                      id: souceItem.id,
                      article: souceItem.article,
                      title: souceItem.title,
                      count: souceItem.count,
                      price: souceItem.price,
                      oldPrice: souceItem.oldPrice
                    };
                    return acc;
                }, {})              
            }
    
            return {
                id: hash,
                isMod: false,
                count: item.count,
                isWok: true,
                wokData: WokDataCheck 
            }
        })

        const validateWok = () => {
            const wokGoods = checkGoods.filter((item) => item.isWok);
            if (!wokGoods || wokGoods.length === 0) return true;
            const errorWoks = wokGoods.filter((item) => isEmpty(item.wokData) || isEmpty(item.wokData.souce));
            if (!errorWoks || errorWoks.length === 0) return true;
            const names = errorWoks.map((item) => item.wokData ? item.wokData.main.title : null).filter((item) => item);
            return { error: `В составе сборного ВОКа должен быть соус. ${names ? '(Наименование позиций: ' + names.join(', ') + ')': ''}` };
        }

        const validate = validateWok();
        if (validate && validate.error) return validate;

        const getPoint = () => {
            if (!stateNewOrders.point) return null;
            if (stateNewOrders.point.id) return stateNewOrders.point.id;
            return stateNewOrders.point;
        }

        const point = getPoint();

        const getZone = (point) => {
            if (point) return null;
            if (stateNewOrders.zone) return stateNewOrders.zone;
            return null;
        }

        const getCity = () => {
            if (stateNewOrders.point && stateNewOrders.point.city) return stateNewOrders.point.city;
            if (stateNewOrders.zone && stateNewOrders.zone.city) return stateNewOrders.zone.city;
            return stateNewOrders.city;
        }

        const city = getCity();
        const timeZone = (city && city.timeZone) ? city.timeZone : '+03';
        const visible_datetime = stateNewOrders.visible_datetime ? moment(stateNewOrders.visible_datetime).utcOffset(`${timeZone}:00`, true).toISOString() : null;
        const newOrder = {
            deliveryMethod: stateNewOrders.deliveryMethod,
            point,
            city: city ? city.id : null,        
            phone: stateNewOrders.phone ? String(stateNewOrders.phone) : null,
            internalComment: checkComment ? checkComment : null,
            timeMethod: stateNewOrders.timeMethod ? stateNewOrders.timeMethod : 'fast',
            deliveryPrice: stateNewOrders.deliveryPrice,
            deliveryArticle: stateNewOrders.deliveryArticle,
            deliveryTime: stateNewOrders.deliveryTime ? stateNewOrders.deliveryTime : null,
            deliveryTimeComment: stateNewOrders.deliveryTimeComment ? stateNewOrders.deliveryTimeComment : null,
            totalPrice: parseFloat(stateNewOrders.totalPrice),
            goodsPrice: parseFloat(stateNewOrders.goodsPrice),
            salePrice: parseFloat(stateNewOrders.salePrice),
            unit: parseInt(stateNewOrders.unit) ? parseInt(stateNewOrders.unit) : null,
            goods: checkGoods,
            payment: stateNewOrders.payment,
            changeCash: checkChangeCash,
            newApi: true,
            isSite: stateNewOrders.isSite ? stateNewOrders.isSite : false,
            isAggPrice: stateNewOrders.isAggPrice,
            bonusCount: stateNewOrders.bonusCount ? stateNewOrders.bonusCount : 0,
            zone: getZone(point),
            user: stateNewOrders.user && !isEmpty(stateNewOrders.user) ? stateNewOrders.user : null,
            username: stateNewOrders.username ? stateNewOrders.username : null,
            source: stateNewOrders.source ? stateNewOrders.source : 'crm',
            visible_datetime,
            changeLog: changeLog,
            tags: (stateNewOrders.tags && stateNewOrders.tags.length > 0) ? stateNewOrders.tags : null,
            sale: stateNewOrders.sale ? stateNewOrders.sale : null,
            promotion: stateNewOrders.promotion ? stateNewOrders.promotion : null,
            promocode: stateNewOrders.promocode ? stateNewOrders.promocode : null,
            timeZone,
            aggData: stateNewOrders.aggData,
            isConsumption: stateNewOrders.isConsumption,
            workingShiftId: stateNewOrders.visible_datetime ? null : stateNewOrders.workingShiftId || null,
        }

        if (statusChangeLog) {
            const statusOption = optionsStatus.find(item => item.value === stateNewOrders.status);
            newOrder.status = stateNewOrders.status;
            newOrder.visibleClientStatus = statusOption ? (statusOption.client || statusOption.label) : null;
            newOrder.ignoreFiscalized = true;
            newOrder.ignoreConsumption = true;
            newOrder.changeStatusLog = statusChangeLog;
        }

        if(!window.location.pathname.includes('/edit')) {
            newOrder.authorRole = userInfo.role.id;
            const username = userInfo.name ? userInfo.name : userInfo.username;
            const roleDescription = userInfo.role && userInfo.role.description ? userInfo.role.description : ''
            const userText = `${username} ${roleDescription}`;
            newOrder.author = userText;
        }
    
        if(stateNewOrders.deliveryMethod === 'delivery') {
            newOrder.street = stateNewOrders.street;
            newOrder.house = stateNewOrders.house;
            newOrder.room = stateNewOrders.room;
            newOrder.entrance = stateNewOrders.entrance;
            newOrder.floor = stateNewOrders.floor;
            newOrder.area = stateNewOrders.area;
        }
        
        if (newOrder.isConsumption && (!newOrder.point.enableConsumption || !settings.enableConsumption)) newOrder.isConsumption = false;
        return newOrder;
    }

    return (
        <button disabled={!isValidOrder()} className="btn btn-primary" style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}} onClick={handleClickSave}>Сохранить</button>
    );
}

export default withRouter(SaveNewOrderButton);
